import { useEffect } from 'react';
import { TITLE } from '../config/domain';

interface SEOMetaData {
  title: string;
  description: string;
  keywords: string[];
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  canonicalUrl?: string;
}

export const useSEO = (data: SEOMetaData) => {
  useEffect(() => {
    // Title
    document.title = data.title;

    // Meta description
    updateMetaTag('meta[name="description"]', 'name', 'description', data.description);

    // Meta keywords
    updateMetaTag('meta[name="keywords"]', 'name', 'keywords', data.keywords.join(', '));

    // Canonical URL
    if (data.canonicalUrl) {
      updateLinkTag('link[rel="canonical"]', 'rel', 'canonical', data.canonicalUrl);
    }

    // Open Graph tags
    const ogData = [
      { property: 'og:title', content: data.ogTitle || data.title },
      { property: 'og:description', content: data.ogDescription || data.description },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: TITLE },
      { property: 'og:locale', content: 'it_IT' }
    ];

    if (data.ogUrl) {
      ogData.push({ property: 'og:url', content: data.ogUrl });
    }

    ogData.forEach(({ property, content }) => {
      updateMetaTag(`meta[property="${property}"]`, 'property', property, content);
    });

    // Twitter Card
    const twitterData = [
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: data.ogTitle || data.title },
      { name: 'twitter:description', content: data.ogDescription || data.description }
    ];

    twitterData.forEach(({ name, content }) => {
      updateMetaTag(`meta[name="${name}"]`, 'name', name, content);
    });

  }, [data]);
};

const updateMetaTag = (selector: string, attrName: string, attrValue: string, content: string) => {
  let tag = document.querySelector(selector);
  if (tag) {
    tag.setAttribute('content', content);
  } else {
    tag = document.createElement('meta');
    tag.setAttribute(attrName, attrValue);
    tag.setAttribute('content', content);
    document.head.appendChild(tag);
  }
};

const updateLinkTag = (selector: string, attrName: string, attrValue: string, href: string) => {
  let tag = document.querySelector(selector);
  if (tag) {
    tag.setAttribute('href', href);
  } else {
    tag = document.createElement('link');
    tag.setAttribute(attrName, attrValue);
    tag.setAttribute('href', href);
    document.head.appendChild(tag);
  }
};
